<template>
  <div class="auction-info">
    <car-info-head
      :car-images="car.auction_car.images"
      :car-info="car.auction_car.car_info"
      :start-price="car.auction.minimum_price"
      :quote-increment="car.auction.quote_increment"
       @click-swiper="clickSwiper">
    </car-info-head>
    <images-previewer :list="car.auction_car.images" ref="previewer" :options="options" :w='600' :h='400'></images-previewer>
    <group
      gutter="0"
      class="group-no-before"
    >
      <cell class="cell-no-before">
        <span v-if="car.hasOwnProperty('scrap')" slot="icon" class="fc-gray">车辆收入 </span>
        <span v-else slot="icon" class="fc-gray">成交价格 </span>
        <div slot="after-title">
          <span class="fs40 fc-ce3b28">{{(outBound.deal_price / 100).toFixed(2)}}</span><em class="fc-red">元</em>
        </div>
      </cell>
      <cell
        class="v-cell-box v-cell-common"
        :inline-desc="inlineDesc">
        <div slot="after-title" class="end-time fc-gray">
          <span>{{submitDesc}}</span>
        </div>
      </cell>
    </group>
    <!-- 车辆相关信息 -->
    <car-config
      :car-info="car.auction_car.car_info"
      :car="car"
      :from="from">
    </car-config>
  </div>
</template>
<script>
// 详情页
import {
  Cell,
  Group
  // Previewer
} from '@lx-frontend/cvux'
import util from '../../common/util'
// 引入自定义组件
import CarInfoHead from './components/CarInfoHead'
import CarConfig from './components/CarConfig'
import ImagesPreviewer from '@lx-frontend/images-previewer'
export default {
  components: {
    Cell,
    Group,
    // Previewer,
    CarInfoHead,
    CarConfig,
    ImagesPreviewer
  },

  data() {
    return {
      options: {
        getThumbBoundsFn (index) {
          let isServer = typeof window === 'undefined'
          if (isServer) return
          // find thumbnail element
          let thumbnail = document.querySelectorAll('.vux-img')[index]
          // get window scroll Y
          let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
          // optionally get horizontal scroll
          // get position of element relative to viewport
          let rect = thumbnail.getBoundingClientRect()
          // w = width
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
          // Good guide on how to get element coordinates:
          // http://javascript.info/tutorial/coordinates
        }
      },
      car: {
        auction: {},
        auction_car: {
          images: [],
          car_info: {}
        },
        store: {
          name: ''
        }
      }, // 车辆详情
      outBound: {
        deal_price: 0
      },
      inlineDesc: '',
      submitDesc: '',
      from: '' //
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    clickSwiper(item) {
      this.$refs.previewer.show(item)
    },
    render(arr = []) {
      arr.map((v, i) => {
        let img = new window.Image()
        img.src = v.src
        // 如果图片被缓存，则直接返回缓存数据
        if (img.complete) {
          v.w = img.width
          v.h = img.height
          this.imgCount++
        } else {
          // 完全加载完毕的事件
          img.onload = () => {
            v.w = img.width
            v.h = img.height
            this.imgCount++
          }
        }
      })
      return arr
    },
    initPage () {
      let queryUrl = ''
      let queryId = this.$route.params.id
      //
      let from = this.$route.query.from
      // 报废、零售、批售、特殊出库的车辆详情 from 状态 为 outbound
      // 出库审核中 为 outBoundReview。 2者需要调用不同的接口

      if (from === 'outBoundReview') {
        queryUrl = `outbound_requests/${queryId}/car_details`
      } else {
        queryUrl = `outbound_car_detail/${queryId}`
      }
      // 把来路赋值给from。后续查看报告需要通过该来路得到动态请求信息
      this.from = from
      this.$rest.outBound.getOutBoundCarDetail(null, queryUrl).then((res) => {
        if (res.code === 0) {
          if (!res.data.auction || !res.data.auction.minimum_price) {
            this.car = Object.assign({}, res.data, {
              auction: {
                minimum_price: 0
              }
            })
          } else {
            this.car = res.data
          }
          if (res.data.hasOwnProperty('batch_sale')) {
            util.changeTitle('批售车辆详情')
            this.outBound = res.data.batch_sale
            switch (res.data.batch_sale.dealer_type) {
              case 'lixin':
                this.outBound.dealer_type = '立新车市的有效车商'
                break
              case 'non_lixin':
                this.outBound.dealer_type = '非立新车市车商'
                break
              case 'other':
                this.outBound.dealer_type = '其他平台'
                break
              default:
                break
            }
            this.inlineDesc = `${this.outBound.dealer_type}：${this.outBound.buyer_name} ${this.outBound.buyer_mobile} ${this.outBound.dealer_name}`
            this.submitDesc = `车辆在${this.outBound.submit_at}提交批售`
          }
          if (res.data.hasOwnProperty('retail')) {
            util.changeTitle('零售车辆详情')
            this.outBound = res.data.retail
            this.inlineDesc = `客户信息：${this.outBound.buyer_name} ${this.outBound.buyer_mobile}`
            this.submitDesc = `车辆在${this.outBound.submit_at}提交零售`
          }
          if (res.data.hasOwnProperty('scrap')) {
            util.changeTitle('报废车辆详情')
            this.outBound = res.data.scrap
            this.submitDesc = `车辆在${this.outBound.submit_at}提交报废`
          }
          if (res.data.hasOwnProperty('special')) {
            util.changeTitle('特殊车辆详情')
            this.outBound = res.data.special
            this.inlineDesc = `客户信息：${this.outBound.buyer_name} ${this.outBound.buyer_mobile}`
            this.submitDesc = `车辆在${this.outBound.submit_at}提交特殊出库`
          }
          let images = this.car.auction_car.images
          if (images.length > 0) {
            images.forEach((item, index) => {
              this.car.auction_car.images[index].src = item.image_url
            })
            this.car.auction_car.images = this.render(images)
          }
        } else {
          this.showToast(res.message)
        }
      })
    },
    changeImagesIndex (index) {
      this.imageIndex = index
    }
  },
  watch: {
    '$route' () {
      this.initPage()
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import "../../stylesheets/global.less";
  .auction-info {
    .vux-no-group-title {
      margin-top:0;
    }
    .weui_cell_ft {
      text-align: right;
    }
    .icon-img{
      display: inline-block;
      width: 18px;
      vertical-align: middle;
    }
    .vux-flexbox.title {
      padding-top: 40/@w2;
    }
    .fs26 .weui_cell_hd span {
      margin-right: 30/@w;
      font-size: 26/@w2;
    }
    .flexbox {
      align-items: flex-start;
      line-height: 60/@w2;
      padding-bottom: 20/@w2;
      .title {
        font-size: 30/@w2;
      }
      .key {
        color: #9a9a9a;
        font-size: 26/@w2;
        line-height: 1.4;
      }
      .value {
        font-size: 26/@w2;
        line-height: 1.4;
      }
    }
    .weui_cell.title {
      padding: 56/@w2 0.4rem 30/@w2;
    }
  }

  .auction-info {
    .weui_cells:after{ display: none}
    .txt-bottom {
      padding-top: 156/@w2;
    }
    .txt-fix {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      color: #9a9a9a;
      line-height: 44/@w2;
      text-align: center;
      font-size: 26/@w2;
      background: #eeedee;
      padding: 14/@w2 30/@w2;
    }
    .weui_cells {
      font-size: 26/@w2;
    }
    .num {
      background: #ce3b28;
      width: 40/@w2;
      height: 50/@w2;
      line-height: 50/@w2;
      color: #fff;
      font-size: 30/@w2;
      display: inline-block;
      .radius(8/@w2);
      margin: 0 3/@w2;
      text-align: center;
    }
    .no-surpass-price .num {
      background: #a7a7b1;
    }
    .swiper-car1 {
      position: relative;
    }
    .swiper-car2 {
      background: #fff;
    }
    .v-cell-box {
      background: #f0f0f0;
      padding: 30/@w2;
      margin: 30/@w2;
      .radius(8/@w2);
      border-bottom: 1px solid #bdbdc5;
      font-size: 30/@w2;
      .vux-label-desc {
        margin-top: 10/@w2;
        color: #5d5d5d;
        font-size: 26/@w2;
      }
      line-height: 40/@w2;
    }
    .v-cell-box:before {
      display: none;
    }
    .v-mt {
      margin-top: -20/@w2;
      margin-bottom: 0;
      .weui_cell_primary {
        p {
          line-height: 1.3
        }
      }
    }
    .cell-no-before:before {
      display: none;
    }
    .cell-no-before .weui_cell_primary > p > div {
      margin-left: 16/@w2;
    }
    .group-no-before .weui_cells {
      line-height: 1.941176467733564;
    }
    .group-no-before .weui_cells:before {
      display: none;
    }
    .v-cell-common .vux-label-desc {
      color: #ce3b28;
    }
    .v-cell-common {
      border: none;
      .radius(16/@w2);
    }
    .fs40 {
      font-size: 40/@w2;
    }
    .text {
      padding: 0 30/@w2 30/@w2 30/@w2;
      color: #5d5d5d;
      font-size: 26/@w2;
    }
    .after-title {
      color: #9a9a9a;
      font-size: 26/@w2;
    }
    .cell-no-before button {
      background: #a7a7b1;
      color: #fff;
      border-radius: 50px 0 0 50px;
      height: 50/@w2;
      line-height: 50/@w2;
      right: 0;
      top: 50%;
      position: absolute;
      margin-top: -25/@w2 !important;
      font-size: 26/@w2;
      &:after {
        display: none;
      }
    }
    .cell-no-before {
      padding: 0 30/@w2;
      margin-top: 30/@w2;
      .fc-gray {
        color: #5d5d5d;
        font-size: 26/@w2;
      }
      .fc-red {
        color: #ce3b28;
        font-size: 26/@w2;
      }
    }

    .v-auction-disable .cell-no-before button {
      background: #a7a7b1;
    }
    .v-auction-disable .cell-no-before .fc-red {
      color: #ce3b28;
      font-size: 26/@w2;
    }
    .v-auction-working .cell-no-before button {
      background: #ff5a22;
    }
    .v-auction-success .cell-no-before button {
      background: #1aad19;
    }
    .auction-detail .weui_cell:before {
      display: none
    }
    .auction-detail .order-state .order-check li .info-label {
      width: 180/@w2;
    }
    .detail {
      color: #9a9a9a;
      line-height: 40/@w2;
      margin-bottom: 26/@w2;
      margin-left: 30/@w2;
      padding-right: 0.4rem;
    }
    .fc-blue {
      color: #6682ba;
    }
    .v-cell-common .end-time {
      font-size: 26/@w2;
      color: #5d5d5d
    }

  }
</style>
